import { render, staticRenderFns } from "./product.vue?vue&type=template&id=3a0455ae&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=3a0455ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0455ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a0455ae')) {
      api.createRecord('3a0455ae', component.options)
    } else {
      api.reload('3a0455ae', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=3a0455ae&scoped=true&", function () {
      api.rerender('3a0455ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/product.vue"
export default component.exports